var DropDown = require('../../../../common/dropDown/dropDownWr.js');

module.exports = DropDown.extend({
    template: require('./rotate.hbs'),
    onChange: function(txt, val) {
        this.options.vChannel.request('rotatePgRequest', val.deg);
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/rotate/rotate.js
 ** module id = 724
 ** module chunks = 0
 **/